module.exports = require('../internals/global');



//////////////////
// WEBPACK FOOTER
// ./node_modules/irc-framework/node_modules/core-js/internals/path.js
// module id = l034
// module chunks = 0